import { useMutation } from "react-query";
import { BlocoQuadraForm } from "../typings";
import http from "infra/http";

function useCreateBlocoQuadra(tenantId: string | null) {
  return useMutation(
    `/v1/tenants/${tenantId}/bloco-quadra/unidadeId`,
    (data: BlocoQuadraForm) =>
      http.post(`/v1/tenants/${tenantId}/bloco-quadra`, data),
    { retry: false }
  );
}

export default useCreateBlocoQuadra;
